import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { polarisProductViewBlueprintsSettingsEntryPoint } from '@atlassian/jira-spa-apps-polaris-settings-view-blueprints/polarisProductViewBlueprintsSettingsEntryPoint.tsx';

export const polarisProductViewBlueprintsSettingsPageEntryPoint = createPageEntryPoint({
	main: polarisProductViewBlueprintsSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
